<ng-container>
  {{ trueFalseString }}
</ng-container>
